module.exports = __webpack_public_path__ + "static/bg_hero_sede_84-66bb1631f41baf16daca741b62fcea1e.png";